import _ from 'lodash';

import {UserType, notApplicableId} from '../../../util/uiconstants';
import {labels} from '../../../util/utils';

export default (contacts, payload, hasAccess, entityAdmins, isRootEntity, isGroupRiskAssessment) => {
	let userType = _.isEmpty(payload.userType) ? UserType.Guest : payload.userType;

	let filteredContacts = [];
	if (!_.isEmpty(contacts)) {
		if (
			payload?.isProjectOwner ||
			(hasAccess && isCurrentUserAContactOfCurrentEntity(contacts, entityAdmins, payload.userId, userType))
		) {
			filteredContacts = contacts;
		} else {
			// Not Project Owner, Is not a Part of the Entity
			if (hasAccess || isRootEntity) {
				if (isGroupRiskAssessment && isRootEntity) {
					filteredContacts = contacts;
				} else {
					filteredContacts = contacts.filter(
						(c) => c.tags.some((t) => !t.isCustom) || (userType === UserType.Guest && c.userId === payload.userId)
					);
				}
			}
		}
	}

	if (payload?.isContactsPage && !_.isEmpty(payload?.engagementMetaData)) {
		filteredContacts = filteredContacts?.map((filteredContact) => {
			let newEngagements = [];
			filteredContact?.engagements?.forEach((engagementContact) => {
				let engagement = payload.engagementMetaData?.find(
					(engagement) => engagement.id === engagementContact.engagementId
				);

				if (engagement !== undefined) {
					newEngagements.push(engagement);
				}
			});

			filteredContact.engagements = newEngagements;
			return filteredContact;
		});
	}

	if (payload?.isContactsPage) {
		filteredContacts = filteredContacts?.map((contact) => {
			if (contact?.roleId === undefined) {
				contact.roleId = notApplicableId;
				contact.roleName = labels.notApplicable;
			}

			if (contact?.serviceLineId === undefined) {
				contact.serviceLineId = notApplicableId;
				contact.serviceLineName = labels.notApplicable;
			}

			return contact;
		});
	}

	return filteredContacts;
};

const isCurrentUserAContactOfCurrentEntity = (contacts, entityAdmins, userId, userType) => {
	const isEntityAdmin = entityAdmins?.some((admin) => admin.userId === userId);
	let found = false;
	if (isEntityAdmin) {
		found = true;
	} else {
		if (userType === UserType.Member) {
			found = contacts.some((contact) => contact.userId === userId);
		}
	}
	return found;
};
